import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { OtpEndPoient, resendOtpEndPoient } from "src/app/Data/service/global.service";
import { AuthService } from "../service/auth.service";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AppleDeviceService } from "../../services/apple-device.service";
import { AndroidDeviceService } from "../../services/android-device.service";
import { NotificationService } from "../../Data/service/notification.service";
import { MustChangePasswordService } from "../../services/must-change-password.service";
import { HttpConfigInterceptor } from "../../interciptor/jwt.interceptor";
import Swal from 'sweetalert2';

@Component({
  selector: "app-otp",
  templateUrl: "./otp.component.html",
  styleUrls: ["./otp.component.scss"]
})
export class OtpComponent implements OnInit {
  curentLang: string = "";
  public show: boolean = false;
  error: string = '';
  userRegistId: any;
  otpCode: string = '';
  /** وضع تسجيل الدخول بـ OTP (6 أرقام) مقابل التحقق من التسجيل (4 أرقام) */
  isLoginOtpMode = false;
  otpRequiredLength = 4;
  resendDisabled = false;
  resendSecondsLeft: number | null = null;
  private resendTimerId: any = null;
  /** When true, after successful login OTP we mark this device as trusted (no popup). */
  addToTrustedDevices = false;
  /** Shown in OTP step: trust lasts 30 days only. */
  trustDurationDays = 30;

  constructor(
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private Router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private appleDeviceService: AppleDeviceService,
    private androidDeviceService: AndroidDeviceService,
    private notificationService: NotificationService,
    private mustChangePasswordService: MustChangePasswordService,
  ) {
    this.curentLang = localStorage.getItem('curentLang') || 'en';
  }

  otp() {
    if (this.isLoginOtpMode) {
      this.submitLoginOtpVerify();
    } else {
      this.submitRegisterOtp();
    }
  }

  private submitLoginOtpVerify() {
    const ctx = this.authService.loginOtpContext;
    const cleanedOtp = this.normalizeOtpCode(this.otpCode);
    this.otpCode = cleanedOtp;

    if (!ctx?.phone_number) {
      const msg = this.curentLang === 'ar'
        ? 'انتهت جلسة تسجيل الدخول. يرجى تسجيل الدخول مرة أخرى.'
        : (this.curentLang === 'he'
          ? 'פג תוקף ההתחברות. אנא התחבר שוב.'
          : 'Login session expired. Please sign in again.');
      Swal.fire({ icon: 'warning', title: msg });
      this.Router.navigate(['/login']);
      return;
    }
    if (!cleanedOtp) {
      const msg = this.curentLang === 'ar'
        ? 'يرجى إدخال رمز التحقق.'
        : (this.curentLang === 'he' ? 'אנא הזן את קוד האימות.' : 'Please enter the verification code.');
      Swal.fire({ icon: 'warning', title: msg });
      return;
    }
    if (cleanedOtp.length !== 6) {
      const msg = this.curentLang === 'ar'
        ? 'رمز التحقق يجب أن يكون 6 أرقام.'
        : (this.curentLang === 'he' ? 'קוד האימות חייב להיות בן 6 ספרות.' : 'The verification code must be 6 digits.');
      Swal.fire({ icon: 'warning', title: msg });
      return;
    }

    const otpNum = parseInt(cleanedOtp, 10);
    if (isNaN(otpNum)) return;

    this.spinner.show();
    this.authService.loginOtpVerify({ phone_number: ctx.phone_number, otp: otpNum }).subscribe({
      next: (res) => {
        if (res.status === 200) {
          this.authService.loginOtpContext = null;
          HttpConfigInterceptor.resetSessionExpiredToastFlag();
          localStorage.setItem('token', res.accessToken);
          if (res.refreshToken) localStorage.setItem('refreshToken', res.refreshToken);
          localStorage.setItem('user_type', res.userData.user_type);
          localStorage.setItem('userType_en', res.userData.userType_en);
          localStorage.setItem('user_id', res.userData.user_id);
          localStorage.setItem('office_id', res.userData.office_id);
          localStorage.setItem('merchant_id', res.userData.merchant_id);
          localStorage.setItem('companyDefault', res.userData.company_default);
          localStorage.setItem('curentLang', res.userData.language);
          this.authService.saveCurrentUser();
          // Fire-and-forget side effects — wrapped so any error never prevents navigation.
          try {
            this.notificationService.checkPermissionAndRequest(res.userData.user_id);
          } catch { /* non-critical */ }
          // Silent fire-and-forget: overwrite IP-based location with exact browser coordinates
          this.authService.getBrowserLocation().then((loc) => {
            if (loc) { this.authService.updateSessionLocation(loc.city, loc.country).subscribe({ error: () => {} }); }
          });
          if (res.mustChangePassword === true) {
            this.mustChangePasswordService.setRequired(res.userData?.phone_number || ctx.phone_number);
          }

          // Navigate immediately — never block login on trusted-device API (fixes real-mobile hang).
          this.navigateAfterOtpLogin(res);

          const shouldMarkTrusted = this.addToTrustedDevices && !res.deviceAlreadyTrusted;
          if (shouldMarkTrusted) {
            this.markDeviceTrustedInBackground();
          }
        } else if (res.status === 400 && res.code === 'OTP_INVALID') {
          const msg = this.curentLang === 'ar' ? (res.messageAr || 'رمز التحقق غير صحيح.') : (this.curentLang === 'he' ? (res.messageHe || 'קוד האימות שגוי.') : (res.messageEn || 'Invalid OTP code.'));
          Swal.fire({ icon: 'error', title: msg });
        } else if (res.status === 403) {
          const msg = this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe);
          if (res.code === 'IP_BLOCKED' && res.blockedUntil) {
            const until = this.curentLang === 'ar' ? ` حتى ${new Date(res.blockedUntil).toLocaleString('ar')}` : (this.curentLang === 'he' ? ` עד ${new Date(res.blockedUntil).toLocaleString('he')}` : ` until ${new Date(res.blockedUntil).toLocaleString('en')}`);
            Swal.fire({ icon: 'error', title: msg + until });
          } else {
            Swal.fire({ icon: 'error', title: msg });
          }
        } else if (res.status === 429) {
          const rateMsg = this.curentLang === 'ar' ? 'محاولات كثيرة. انتظر دقيقة ثم حاول مجدداً.' : (this.curentLang === 'he' ? 'יותר מדי ניסיונות. חכה דקה ונסה שוב.' : 'Too many attempts. Please wait a minute and try again.');
          Swal.fire({ icon: 'warning', title: rateMsg });
        } else {
          const errorMessage = this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe);
          Swal.fire({ icon: 'error', title: errorMessage || (this.curentLang === 'ar' ? 'حدث خطأ' : 'An error occurred') });
        }
      },
      error: (err) => {
        const msg = err?.error?.messageAr || err?.error?.messageEn || err?.error?.messageHe || (this.curentLang === 'ar' ? 'حدث خطأ في الاتصال.' : 'Connection error.');
        Swal.fire({ icon: 'error', title: msg });
      },
      complete: () => this.spinner.hide()
    });
  }

  private navigateAfterOtpLogin(res: any) {
    const userType = res.userData.user_type;
    const target =
      userType === 100 || userType === 101
        ? '/dashboard/dashboard'
        : (userType === 300 || userType === 301)
          ? '/dashboard/office-companies'
          : '/dashboard/dashboard';

    this.authService.isLogin.next(true);
    this.Router.navigate([target]).then(() => {
      this.appleDeviceService.recheckBannerVisibility();
      this.androidDeviceService.recheckBannerVisibility();
    });
  }

  /** Fire-and-forget: mark device trusted without blocking navigation. */
  private markDeviceTrustedInBackground(): void {
    this.authService.markCurrentDeviceTrusted().subscribe({
      error: () => {
        // Login already succeeded; don't interrupt the user with an error popup.
      },
    });
  }

  /** Strip non-digits (iOS SMS autofill may insert spaces/dashes). */
  private normalizeOtpCode(raw: string): string {
    return (raw || '').replace(/\D/g, '');
  }

  onOtpInput(): void {
    this.otpCode = this.normalizeOtpCode(this.otpCode);
  }

  /** إعادة إرسال كود OTP في وضع تسجيل الدخول بخطوتين */
  resendLoginOtp() {
    if (!this.isLoginOtpMode || this.resendDisabled) {
      return;
    }
    const ctx = this.authService.loginOtpContext;
    if (!ctx?.phone_number) return;

    const model = { phone_number: ctx.phone_number };
    this.spinner.show();
    this.authService.resendOtp(resendOtpEndPoient.POST, model).subscribe({
      next: (res) => {
        const status = res.status;
        const msg = this.curentLang === 'ar'
          ? res.messageAr
          : (this.curentLang === 'en' ? res.messageEn : res.messageHe);

        if (status === 200) {
          Swal.fire({ icon: 'success', title: msg });
        } else if (status === 400 || status === 404) {
          Swal.fire({ icon: 'warning', title: msg });
        } else {
          Swal.fire({
            icon: 'error',
            title: msg || (this.curentLang === 'ar'
              ? 'حدث خطأ'
              : (this.curentLang === 'he' ? 'אירעה שגיאה' : 'An error occurred'))
          });
        }

        // منع السبام من الواجهة لمدة 60 ثانية تقريباً مع عداد ثواني
        if (status === 200 || status === 400) {
          this.startResendCountdown(60);
        }
      },
      error: (err) => {
        const msg = err?.error?.messageAr || err?.error?.messageEn || err?.error?.messageHe
          || (this.curentLang === 'ar' ? 'حدث خطأ في الاتصال.' : 'Connection error.');
        Swal.fire({ icon: 'error', title: msg });
      },
      complete: () => this.spinner.hide()
    });
  }

  /** يبدأ عداد الثواني قبل تمكين زر إعادة الإرسال */
  private startResendCountdown(seconds: number = 60) {
    if (this.resendTimerId) {
      clearInterval(this.resendTimerId);
      this.resendTimerId = null;
    }
    this.resendSecondsLeft = seconds;
    this.resendDisabled = true;
    this.resendTimerId = setInterval(() => {
      if (this.resendSecondsLeft !== null && this.resendSecondsLeft > 0) {
        this.resendSecondsLeft--;
      }
      if (this.resendSecondsLeft !== null && this.resendSecondsLeft <= 0) {
        this.resendDisabled = false;
        this.resendSecondsLeft = 0;
        clearInterval(this.resendTimerId);
        this.resendTimerId = null;
      }
    }, 1000);
  }

  private submitRegisterOtp() {
    const model = { user_id: Number(this.userRegistId), otp: this.otpCode };
    this.spinner.show();
    this.authService.Otp(OtpEndPoient.POST, model).subscribe((res) => {
      if (res.status === 200) {
        Swal.fire({
          icon: 'success',
          title: this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe)
        });
        localStorage.setItem('user_type', res.userData.user_type);
        localStorage.setItem('userType_en', res.userData.userType_en);
        localStorage.setItem('user_id', res.userData.user_id);
        localStorage.setItem('office_id', res.userData.office_id);
        localStorage.setItem('merchant_id', res.userData.merchant_id);
        localStorage.setItem('curentLang', res.userData.language);
        if (res.accessToken) {
          HttpConfigInterceptor.resetSessionExpiredToastFlag();
          localStorage.setItem('token', res.accessToken);
          this.authService.saveCurrentUser();
        }
        this.appleDeviceService.recheckBannerVisibility();
        this.androidDeviceService.recheckBannerVisibility();
        this.Router.navigate(['/dashboard/dashboard']);
        this.authService.isLogin.next(true);
      } else if (res.status === 400 || res.status === 403 || res.status === 500 || res.status === 404) {
        const errorMessage = this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe);
        Swal.fire({ icon: 'error', title: errorMessage });
      }
      this.spinner.hide();
    });
  }

  ngOnInit() {
    this.spinner.show();
    setTimeout(() => this.spinner.hide(), 1000);
    this.isLoginOtpMode = !!this.authService.loginOtpContext || this.route.snapshot.queryParams['mode'] === 'login-otp';
    if (this.isLoginOtpMode) {
      this.otpRequiredLength = 6;
      if (!this.authService.loginOtpContext) {
        this.Router.navigate(['/login']);
        return;
      }
      // عند فتح شاشة OTP للّوجين ابدأ عداد الدقيقة قبل السماح بإعادة الإرسال
      this.startResendCountdown(60);
    } else {
      this.otpRequiredLength = 4;
      try {
        this.userRegistId = JSON.parse(localStorage.getItem('user_id') || 'null');
      } catch {
        this.userRegistId = null;
      }
    }
  }

  showPassword() {
    this.show = !this.show;
  }

  isNumber(event: KeyboardEvent) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    } else {
      return true;
    }
  }
}
